import { Injectable, Injector } from '@angular/core';

import { Question } from './question';
import { HttpDataService } from 'core/services/http-data.service';
import { lastValueFrom } from 'rxjs';

@Injectable()
export class QuestionsService extends HttpDataService {
  public list: Question[];

  constructor(protected injector: Injector) {
    super(injector, '/customizations/ada/questions');
  }

  resolve(): Promise<Question[]> | Question[] {
    if (this.list) {
      return this.list;
    }
    return this.fetch().then((questions) => (this.list = questions.docs));
  }

  getQuestion(id: string): Promise<any> {
    const url = `${this.baseUrl}/${id}`;
    return lastValueFrom(this.http.get<Question>(url, this.getRequestOptions()))
      .then((response) => response)
      .catch((error) => this.handlePromiseError(error));
  }
}
